var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalaxy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 108,
    viewBox: "0 0 244 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_473_2368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 58C14 31.4903 35.4903 10 62 10H190C212.091 10 230 27.9086 230 50C230 72.0914 212.091 90 190 90H14V58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 58C14.5 31.7665 35.7665 10.5 62 10.5H190C211.815 10.5 229.5 28.1848 229.5 50C229.5 71.8152 211.815 89.5 190 89.5H14.5V58Z",
    stroke: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8109 44.74C71.3422 43.8767 70.6639 43.223 69.7759 42.779C68.9126 42.3103 67.8889 42.076 66.7049 42.076C64.6576 42.076 63.0172 42.7543 61.7839 44.111C60.5506 45.443 59.9339 47.2313 59.9339 49.476C59.9339 51.8687 60.5752 53.7433 61.8579 55.1C63.1652 56.432 64.9536 57.098 67.2229 57.098C68.7769 57.098 70.0842 56.7033 71.1449 55.914C72.2302 55.1247 73.0196 53.99 73.5129 52.51H65.4839V47.848H79.2479V53.731C78.7792 55.3097 77.9776 56.7773 76.8429 58.134C75.7329 59.4907 74.3146 60.5883 72.5879 61.427C70.8612 62.2657 68.9126 62.685 66.7419 62.685C64.1766 62.685 61.8826 62.13 59.8599 61.02C57.8619 59.8853 56.2956 58.319 55.1609 56.321C54.0509 54.323 53.4959 52.0413 53.4959 49.476C53.4959 46.9107 54.0509 44.629 55.1609 42.631C56.2956 40.6083 57.8619 39.042 59.8599 37.932C61.8579 36.7973 64.1396 36.23 66.7049 36.23C69.8129 36.23 72.4276 36.9823 74.5489 38.487C76.6949 39.9917 78.1132 42.076 78.8039 44.74H71.8109ZM81.4945 52.14C81.4945 50.0187 81.8892 48.1563 82.6785 46.553C83.4925 44.9497 84.5902 43.7163 85.9715 42.853C87.3528 41.9897 88.8945 41.558 90.5965 41.558C92.0518 41.558 93.3222 41.854 94.4075 42.446C95.5175 43.038 96.3685 43.815 96.9605 44.777V41.854H103.287V62.5H96.9605V59.577C96.3438 60.539 95.4805 61.316 94.3705 61.908C93.2852 62.5 92.0148 62.796 90.5595 62.796C88.8822 62.796 87.3528 62.3643 85.9715 61.501C84.5902 60.613 83.4925 59.3673 82.6785 57.764C81.8892 56.136 81.4945 54.2613 81.4945 52.14ZM96.9605 52.177C96.9605 50.5983 96.5165 49.3527 95.6285 48.44C94.7652 47.5273 93.7045 47.071 92.4465 47.071C91.1885 47.071 90.1155 47.5273 89.2275 48.44C88.3642 49.328 87.9325 50.5613 87.9325 52.14C87.9325 53.7187 88.3642 54.9767 89.2275 55.914C90.1155 56.8267 91.1885 57.283 92.4465 57.283C93.7045 57.283 94.7652 56.8267 95.6285 55.914C96.5165 55.0013 96.9605 53.7557 96.9605 52.177ZM114.192 35.12V62.5H107.865V35.12H114.192ZM117.519 52.14C117.519 50.0187 117.914 48.1563 118.703 46.553C119.517 44.9497 120.615 43.7163 121.996 42.853C123.377 41.9897 124.919 41.558 126.621 41.558C128.076 41.558 129.347 41.854 130.432 42.446C131.542 43.038 132.393 43.815 132.985 44.777V41.854H139.312V62.5H132.985V59.577C132.368 60.539 131.505 61.316 130.395 61.908C129.31 62.5 128.039 62.796 126.584 62.796C124.907 62.796 123.377 62.3643 121.996 61.501C120.615 60.613 119.517 59.3673 118.703 57.764C117.914 56.136 117.519 54.2613 117.519 52.14ZM132.985 52.177C132.985 50.5983 132.541 49.3527 131.653 48.44C130.79 47.5273 129.729 47.071 128.471 47.071C127.213 47.071 126.14 47.5273 125.252 48.44C124.389 49.328 123.957 50.5613 123.957 52.14C123.957 53.7187 124.389 54.9767 125.252 55.914C126.14 56.8267 127.213 57.283 128.471 57.283C129.729 57.283 130.79 56.8267 131.653 55.914C132.541 55.0013 132.985 53.7557 132.985 52.177ZM156.099 62.5L152.14 56.765L148.81 62.5H141.965L148.773 51.955L141.78 41.854H148.884L152.843 47.552L156.173 41.854H163.018L156.099 52.251L163.203 62.5H156.099ZM186.731 41.854L173.781 72.305H166.973L171.709 61.797L163.31 41.854H170.377L175.15 54.767L179.886 41.854H186.731Z",
    fill: "url(#paint0_linear_473_2368)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_473_2368",
    x: 0,
    y: 0,
    width: 244,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_473_2368"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_473_2368"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_473_2368",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_473_2368",
    x1: 59.6829,
    y1: 59.5,
    x2: 210.955,
    y2: 45.8714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E5EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000",
    stopOpacity: 0.22
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalaxy);
export default __webpack_public_path__ + "static/media/galaxy.77727fd4ae1796bd013e348c6b61a78f.svg";
export { ForwardRef as ReactComponent };